import React from 'react';
import { classIconSrc, fallbackItemIcon, fallbackSpellIcon, npcIconSrc } from '../constants/pictograms';
import { mediaSrc } from '../utils/media';

interface PictogramProps {
  iconUrl?: string | null;
  type?: string | null;
  name?: string | null;
  kind?: 'item' | 'spell';
  className?: string;
  alt?: string;
}

export function Pictogram({ iconUrl, type, name, kind = 'item', className, alt = '' }: PictogramProps) {
  const fallback = kind === 'spell' ? fallbackSpellIcon(name) : fallbackItemIcon(type, name);
  const src = mediaSrc(iconUrl || fallback);
  const classes = [kind === 'spell' ? 'pictogram-spell' : '', className].filter(Boolean).join(' ');
  return <img className={classes} src={src} alt={alt} aria-hidden={!alt} />;
}

interface ClassMarkProps {
  icon?: string | null;
  klass?: string | null;
  className?: string;
  alt?: string;
}

export function ClassMark({ icon, klass, className, alt = '' }: ClassMarkProps) {
  return <img className={className} src={mediaSrc(classIconSrc(klass, icon))} alt={alt} aria-hidden={!alt} />;
}

interface NpcMarkProps {
  icon?: string | null;
  iconUrl?: string | null;
  npcType?: string | null;
  className?: string;
  alt?: string;
}

export function NpcMark({ icon, iconUrl, npcType, className, alt = '' }: NpcMarkProps) {
  return (
    <img
      className={className}
      src={mediaSrc(iconUrl || npcIconSrc(npcType, icon))}
      alt={alt}
      aria-hidden={!alt}
    />
  );
}
